import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    text-align: center;
  }
`;
const Headline = styled.h2`
  margin-top: 5px;
  margin-bottom: 10px;
  text-align: center;
`;
const EmptyEntity = ({ children, title = void 0 }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Headline, null, title != null ? title : t("empty.nothing_here")), children);
};
export default EmptyEntity;
